export default [
	{
		path: 'room/:video_room_id',
		component: () => import("@views/broadcast/video/room"),
		meta:{
			tabBar: false,
		},
		children: [

			{
				path: 'watch_member',
				component: () => import("@views/broadcast/video/watch_member"),
				meta:{
					tabBar: false,
				},
			}
		]
	},
	{
		path: 'more_advert/:type',
		component: () => import("@views/broadcast/video/more_advert"),
		meta:{
			tabBar: false,
		},
	},
	{
		path: 'recommend',
		component: () => import("@views/broadcast/video/recommend"),
		meta:{
			tabBar: false,
		},
	},

]